<template>
  <div class="bright-points">
    <p class="title">亮点功能推荐</p>

    <div class="button-group">
      <!-- 免费版 -->
      <button
        class="btn btn-free"
        :class="type === 'free' ? 'btn-sel-free' : ''"
        @click="versionClick('free')"
      >
        <img src="@/assets/images/yzxBuyEntrance/icon-free.png" class="icon" />
        <span class="text">易纸箱-免费版</span>
      </button>

      <!-- 敏捷版 -->
      <button
        class="btn btn-agile"
        :class="type === 'agile' ? 'btn-sel-agile' : ''"
        @click="versionClick('agile')"
      >
        <img src="@/assets/images/yzxBuyEntrance/icon-agile.png" class="icon" />
        <span class="text">易纸箱-敏捷版</span>
      </button>

      <!-- 专业版 -->
      <button
        class="btn btn-pro"
        :class="type === 'pro' ? 'btn-sel-pro' : ''"
        @click="versionClick('pro')"
      >
        <img src="@/assets/images/yzxBuyEntrance/icon-pro.png" class="icon" />
        <span class="text">易纸箱-专业版</span>
      </button>
    </div>
    <div class="expandable-list">
      <div class="left-list">
        <div v-for="(item, index) in items" :key="index" class="item">
          <div class="header" @click="toggleItem(index)">
            <span class="header-title">{{ item.title }}</span>
            <span class="icon">{{ activeIndex === index ? '-' : '+' }}</span>
          </div>
          <div v-show="activeIndex === index" class="content">
            <!-- <p class="subtitle">{{ item.subTitle }}</p> -->
            <div class="content-detail">
              <img v-if="item.img" :src="item.img" alt="" />
              <video v-else :src="item.video" autoplay></video>
            </div>
            <p class="title-content">{{ item.content }}</p>
            <div class="action-content">
              <div class="action-trail" @click="trailClick">立即试用</div>
              <div class="action-example">
                <router-link to="/benchmarkExample">客户案例</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-list">
        <!-- <div class="content-detail"> -->
        <img v-if="currentImage" :src="currentImage" alt="" />
        <video v-else autoplay :src="currentVideo"></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'brightPoints',
  data() {
    return {
      isBigScreen: false,
      activeIndex: 0,
      type: 'free',
      currentImage: '',
      currentVideo: '',
      list: {
        free: [
          {
            title: 'AI识单买纸板',
            content:
              '告别手动录单，高效识别终端纸箱采购单，批量转化成纸板采购单\n\n省去线下人工计算转化环节，让采购工作快人一步',
            img: require('@/assets/images/yzxBuyEntrance/point-free-1.png')

            // video: require('@/assets/images/video.mp4')
          },
          {
            title: 'AI识单纸板收货',
            content: '无需翻单！纸板到货拍照秒识别，收货入库超省力',
            img: require('@/assets/images/yzxBuyEntrance/point-free-2.png')
            // video: ''
          },
          {
            title: 'AI识单纸板对账',
            content: '无需提前录单！纸板到货拍照秒识别，一键记账实时对账',
            img: require('@/assets/images/yzxBuyEntrance/point-free-3.png')
            // video: ''
          }
        ],
        agile: [
          {
            title: '纸箱送货',
            content:
              '告别手动录单，高效识别终端纸箱采购单，批量转化成纸箱送货单\n\n支持手机远程打印，上传回单永久保存',
            img: require('@/assets/images/yzxBuyEntrance/point-agile-1.png')
            // video: ''
          },
          {
            title: '客户秒级对账',
            content:
              '结算周期自定义设置，灵活高效\n\n按月自动生成对账单，简单、高效',
            img: require('@/assets/images/yzxBuyEntrance/point-agile-2.png')
            // video: ''
          },
          {
            title: '纸箱报价',
            content:
              '告别手工核算，3步生成精准报价\n\n统一管理成本数据，箱型、工艺可配置',
            img: require('@/assets/images/yzxBuyEntrance/point-agile-3.png')
            // video: ''
          }
        ],
        pro: [
          {
            title: '纸箱开单',
            content:
              '自动同步产品档案，同步生成纸板采购单\n\n生产单格式自定义配置',
            img: require('@/assets/images/yzxBuyEntrance/point-pro-1.png')
            // video: ''
          },
          {
            title: '生产排产',
            content:
              '灵活安排生产计划，实时掌握工序生产进度\n\n小程序扫码计件，薪酬轻松统计',
            img: require('@/assets/images/yzxBuyEntrance/point-pro-2.png')
            // video: ''
          },
          {
            title: '库存实时管理',
            content:
              '成品、纸板、辅料等均可管理库存\n\n库存预警、库存资金占用实时监控',
            img: require('@/assets/images/yzxBuyEntrance/point-pro-3.png')
            // video: ''
          }
        ]
      },
      items: []
    }
  },
  created() {},
  mounted() {
    this.items = this.list[this.type]
    this.currentImage = this.items[0].img
    this.currentVideo = this.items[0].video
  },
  methods: {
    toggleItem(index) {
      if (this.activeIndex === index) {
        // this.activeIndex = null
      } else {
        this.activeIndex = index
        this.currentImage = this.items[index].img
        this.currentVideo = this.items[index].video
      }
    },
    trailClick() {
      window.open('https://zxcerptest.cpsol.net/trial.html')
      // this.$router.push({
      //   path: '/product/freeUse'
      // })
    },
    versionClick(type) {
      this.type = type
      this.items = this.list[this.type]
    }
  }
}
</script>

<style lang="scss" scoped>
.bright-points {
  margin-top: 32px;
  padding: 20px;
  // max-width: 1400px;
  // margin: 0 auto;
  background: linear-gradient(180deg, #ffffff 0%, #e7edf7 100%);
  .title {
    text-align: center;
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    // padding-bottom: 40px;
  }

  .button-group {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 10px 0;
    .btn {
      border: none;
      padding: 8px 16px;
      border-radius: 12px;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 6px;
      transition: all 0.3s ease;
    }

    /* 免费版 */
    .btn-free {
      background-color: #fff;
      color: #697d9e;
      border: 1px solid #ddd;
    }

    .btn-sel-free {
      background-color: #e9e9e9;
    }

    /* 敏捷版 */
    .btn-agile {
      background-color: white;
      color: #2770b2;
      border-radius: 8px;
      border: 1px solid #1578d1;
      opacity: 0.5;
    }

    .btn-sel-agile {
      background-color: #f0f8ff;
    }

    /* 专业版 */
    .btn-pro {
      background-color: white;
      color: #95601f;
      border-radius: 8px;
      border: 1px solid #daa02d;
      opacity: 0.5;
    }

    .btn-sel-pro {
      background-color: #fff9f0;
    }

    /* 图标样式 */
    .icon {
      font-size: 16px;
      width: 18px;
    }
  }

  .expandable-list {
    // max-width: 1400px;
    // margin: 0 auto;
    margin: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0px 0 15px 0px rgba(0, 0, 0, 0.07);

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
      cursor: pointer;

      font-weight: 500;
      font-size: 16px;
      color: #333333;
      .header-title {
        font-size: 24px;
        font-weight: bold;
      }
    }
    .left-list {
    }
    .right-list {
      display: none;
    }
    .content {
      padding: 15px 0px;
      border-top: 1px solid #e0e0e0;
      background: linear-gradient(
        180deg,
        rgba(0, 157, 247, 0) 0%,
        rgba(0, 100, 235, 0.05) 100%
      );
      .subtitle {
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        padding: 0 16px;
      }
      .title-content {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        padding: 0 20px;
        word-break: break-all;
        white-space: pre-line;
      }
      .content-detail {
        display: flex;
        justify-content: center;
        // align-items: center;
        margin: 16px 0;
        width: 100%;
        background-image: url('../../../assets/images/yzxBuyEntrance/bg_point.png');
        background-position: center;
        background-size: cover;
        // height: 172px;
        // max-height: 180px;

        padding: 40px;
        img {
          max-width: 80%;
          object-fit: contain;
        }
        video {
          max-width: 80%;
          object-fit: contain;
        }
      }
      .action-content {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        padding: 20px 0;
        .action-trail {
          background: #0064eb;
          height: 38px;
          margin-bottom: 0px;
          margin-right: 11px;
          color: #ffffff;
          width: 134px;
          // border: 1px solid #ffffff;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action-example {
          height: 38px;
          width: 134px;
          background: transparent;
          border: 1px solid #0064eb;
          color: #0064eb;
          display: flex;
          justify-content: center;
          align-items: center;
          a {
            // color: #ffffff;
          }
        }
      }
    }
  }
}

.item {
  border-bottom: 1px solid #ededed;
}

.item:last-child {
  border-bottom: none;
}

.icon {
  font-size: 32px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

@media (min-width: 751px) and (max-width: 960px) {
  .bright-points {
    .expandable-list {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
      .right-list {
      }
    }
  }
}

@media (min-width: 961px) {
  .bright-points {
    .expandable-list {
      max-width: 1400px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.07);
      border-radius: 4px;
      display: flex;
      .left-list {
        width: 40%;
      }
      .content {
        .content-detail {
          display: none;
        }
        .action-content {
          font-size: 14px;
          justify-content: flex-start;
          padding-left: 20px;
          .action-trail {
            width: 127px;
            height: 36px;
          }
          .action-example {
            width: 127px;
            height: 36px;
          }
        }
      }

      .right-list {
        display: flex;
        justify-content: center;
        // align-items: center;
        flex: 1;
        width: 100%;
        background-image: url('../../../assets/images/yzxBuyEntrance/bg_point.png');
        background-position: center;
        background-size: cover;
        max-height: 450px;
        img {
          max-width: 80%;
          object-fit: contain;
        }
        video {
          max-width: 80%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
